module.exports = __webpack_public_path__ + "static/media/metropolis-light.c82170e0.otf";